import React from 'react';
import '../css/PicuPatients.css';
import '../App.css';
import CHOPHeader from './CHOPHeader';
import { useLocation, useNavigate } from "react-router-dom";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import complete from '../img/green-circle.png';
import CustomDialog from "./CustomDialog";
import WriteToLog from '../services/WriteToLog';

const SelectedPatient = () => {
  const location = useLocation();
  const { selectedPatient } = location.state;
  const navigate = useNavigate();

  const routePatient = async (patient, nextPage) => {
    if (patient) {
      if (nextPage === "plan") {
        navigate('/assessment', { state:{selectedPatient: selectedPatient}, replace:true } );
      }

      if (nextPage === "intubate") {
        navigate('/timeout', { state:{selectedPatient: selectedPatient}, replace:true } );
      }

      if (nextPage === "debrief") {
        navigate('/debrief', { state:{selectedPatient: selectedPatient}, replace:true } );
      }
    } else {
      // Error page
      WriteToLog("PicuPatient.routePatient: error routing patient to Plan/Timeout ");
      navigate('/error', { state: {selectedPatient : selectedPatient, failure: "while routing patient to Plan/Timeout" } });
    }
  };

  return (
    <div className="PicuPatients">
      <CHOPHeader/>
      <span><hr></hr></span>
      <h2>{selectedPatient.NURSING_UNIT}</h2> 

      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ padding: "16px 10px" }}>
            <TableCell style={{ fontSize: "18px" }} >Room
            </TableCell>
            <TableCell style={{ fontSize: "18px" }}>Patient</TableCell>
            <TableCell></TableCell>
            <TableCell style={{ fontSize: "18px" }}>Status</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
            <TableRow
              key={selectedPatient.ROOM_BED}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" style={{ fontSize: "18px", padding: "16px 10px"  }}>
                {selectedPatient.ROOM} {selectedPatient.BED}
              </TableCell>
              <TableCell style={{ fontSize: "18px", padding: "16px 10px"  }}><b>{selectedPatient.DISPLAY_NAME}</b> <br></br>{selectedPatient.MRN}</TableCell>
              <TableCell style={{ fontSize: "16px", padding: "16px 10px"  }}>
              {selectedPatient.PLAN_STATUS === "Plan Complete" ? (
                <div><img src={complete} alt=""></img><span>&nbsp;Plan Complete</span><br></br><span className="grey-font">&nbsp;&nbsp;Updated: {selectedPatient.PLAN_COMPLETE_TIMESTAMP}</span></div>
              ) : (
                <div><span>&nbsp;Not Complete</span></div>
              )}
              </TableCell>
              <TableCell style={{ padding: "16px 0px" }}>
                <button onClick={()=>routePatient(selectedPatient, "plan")} className="plan-btn add-margin-right" id="plan">Plan</button>
                {selectedPatient.PLAN_STATUS === "Plan Complete" ? (
                <button onClick={()=>routePatient(selectedPatient, "intubate")} className="intubate-btn" id="intubate">Intubate</button>) : (
                  <CustomDialog patient={selectedPatient} routePatient={routePatient} />
                )}
                <button onClick={()=>routePatient(selectedPatient, "debrief")} className="intubate-btn" id="intubate">Debrief</button>
              </TableCell>
            </TableRow>

        </TableBody>
      </Table>
      </TableContainer>

    </div>
  )
}

export default SelectedPatient;
